/**
 * @file 
 *
 */
'use strict';

/**
 * @classname FormAppendOptionMonthView
 * @classdesc 
 */
export default class FormAppendOptionMonthView {
	/**
	 * @constructor
	 * @param {jQuery} $e - 該当する jQuery オブジェクト
	 */
	constructor($e) {
		console.log('FormAppendOptionMonthView.constructor');
		this._$e = $e;
		this.appendOption();
	};

	appendOption() {
		console.log('FormAppendOptionMonthView.appendOption');
		for(let i = 1; i <= 12; i++) {
			this._$e.append(`<option value="${i}">${i}</option>`);
		}
	}
}
